export const isSiteAllowedByConfig = (sitesConfig) => {
  if (!sitesConfig) {
    return false;
  }
  const currentSite = 'eb';
  return sitesConfig.toLowerCase() === currentSite.toLowerCase();
};
